import { render } from "./SaveWithAlist.vue?vue&type=template&id=7e1054b6"
import script from "./SaveWithAlist.vue?vue&type=script&lang=js"
export * from "./SaveWithAlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__